import { LocalityNameInteractor, LocalityNameRequest, LocalityNameStructRequest } from "../../Coordinator/LocalityName/LocalityNameInteractor";

export class LocalityNameViewModel {
	private interactor: LocalityNameInteractor;

	constructor() {
		this.interactor = new LocalityNameInteractor();
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var request = new LocalityNameRequest(
			obj["sgepnomelocalidade"] ? parseInt(obj["sgepnomelocalidade"]) : 0,
			obj["codigo"] ? obj["codigo"] : "",
			obj["sgepbairros"] ? obj["sgepbairros"] : "",
			obj["sgepdistrito"] ? obj["sgepdistrito"] : "",
		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new LocalityNameStructRequest(obj["sgepnomelocalidade"] ? parseInt(obj["sgepnomelocalidade"]) : 0)
		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}